import { h, Component } from 'preact';
import { Pipe, PipeEntrance, PipeEntranceOutlines } from 'helpers/svgs';
import { pipes } from 'helpers/airportData';
import { isPlanet } from 'helpers/index';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import copy from 'helpers/copy';
import s from 'components/bolt/airport/pipes/pipes.sss';

export default class Pipes extends Component {
	constructor(props) {
		super(props);
		this.needsConstructionIcon = this.hasUnderConstruction();
		this.pipesNeedingAnims = [];
		pipes.map((pipe, i) => {
			if ((pipe.planet && pipe.planet != undefined) || (pipe.easterEgg && pipe.easterEgg != undefined) || (pipe.upWorld && pipe.upWorld != undefined) ) {
				this.pipesNeedingAnims.push(i);
			}
		});
		this.onPipeClick = this.onPipeClick.bind(this);
		this.state = {
			activePipeIndex: null,
			hoveredPipeIndex: null
		};
	}

	async componentDidMount() {
		this.lottie = await import('lottie-web');
		this.pipesNeedingAnims.forEach(pipeIndex => this.loadPipeAnim(pipeIndex));
	}

	componentDidUpdate(prevProps) {
		const { openedWindows } = this.props;
		const { activePipeIndex } = this.state;
		if (prevProps.openedWindows !== openedWindows) {
			const openPlanets = openedWindows.filter(id => isPlanet(id));
			const activePipe = pipes[activePipeIndex];
			if (activePipe && openPlanets.length < 1 || (activePipe?.planet && !openPlanets.includes(activePipe.planet))) {
				this.stopAllPipeAnims();
				this.setState({ activePipeIndex: null });
			}
		}
	}

	componentWillUnmount() {
		this.pipesNeedingAnims.forEach(pipeIndex => {
			this[`pipeAnim${pipeIndex}`]?.destroy();
		});
		this.lottie?.destroy();
	}

	loadPipeAnim(pipeIndex) {
		const { imageRoot } = this.props;
		this[`pipeAnim${pipeIndex}`] = this.lottie.loadAnimation({
			container: this[`$pipeAnimContainer${pipeIndex}`],
			renderer: 'svg',
			rendererSettings: {
				preserveAspectRatio: 'xMidYMid slice'
			},
			loop: false,
			autoplay: false,
			path: `${imageRoot}/airport/lotties/jqwtap/${pipeIndex}.json`
		});
		this[`pipeAnim${pipeIndex}`].addEventListener('complete', () => this.onPipeAnimComplete(pipeIndex));
	}

	onPipeAnimComplete(pipeIndex) {
		const { scrollToUpWorld } = this.props;
		const pipe = pipes[pipeIndex];
		if (pipe.planet) {
			this.props.toggleWindow(pipe.planet);
		}

		if (pipe.upWorld && !pipe.underConstruction) {
			scrollToUpWorld();
			this.setState({ activePipeIndex: null });
		}

		if (pipe.easterEgg) {
			this.props.toggleWindow(pipe.easterEgg);
		}
		this.stopAllPipeAnims();
	}

	onPipeClick(pipeIndex) {
		const pipe = pipes[pipeIndex];

		let eventlabel = pipe.planet ? pipe.planet : pipe.easterEgg ? pipe.easterEgg : pipe.upWorld ? 'spaceJunkGalaxy' : undefined;
		let eventCategory = pipe.planet ? 'planet-overlay' : pipe.easterEgg ? 'video' : pipe.upWorld ? 'up-world' : undefined;
		if (eventlabel != undefined && eventCategory != undefined) {
			Store.emit('CUSTOM_EVENT', {
				category: eventCategory,
				action: 'pipe-click',
				label: eventlabel
			});
		}

		const { sidebarOpen } = this.props;
		if (sidebarOpen) return;
		if (this.state.activePipeIndex === pipeIndex) return;
		
		if (pipe.audio) {
			Store.emit('PLAY_SOUND', pipe.audio);
		}
		if (this[`pipeAnim${pipeIndex}`]) {
			this.stopAllPipeAnims();
			this.setState({ activePipeIndex: pipeIndex });
			this[`pipeAnim${pipeIndex}`].goToAndPlay(0);
		}
		if (pipe.robMsg) {
			Store.emit('ROB_UPDATE', pipe.robMsg);
		}
	}

	onPipeHover(pipeIndex) {
		this.setState({ hoveredPipeIndex: pipeIndex });
	}

	onPipeMouseLeave(pipeIndex) {
		if (this.state.hoveredPipeIndex !== pipeIndex) return;
		this.setState({ hoveredPipeIndex: null });
	}

	stopAllPipeAnims() {
		this.pipesNeedingAnims.forEach(pipeIndex => {
			this[`pipeAnim${pipeIndex}`]?.goToAndStop(0);
		});
	}

	hasUnderConstruction() {
		return pipes.some(pipe => pipe.underConstruction);
	}

	render({ imageRoot, sidebarOpen }) {
		const { activePipeIndex, hoveredPipeIndex } = this.state;
		return (
			<div class={joinClasses(s.container, sidebarOpen && s.fade)}>
				{pipes.map((pipe, i) => ([
					<Pipe
						class={
							joinClasses(
								s.pipe,
								s[`pipe${i}`],
								pipe.underConstruction && s.underConstruction,
								hoveredPipeIndex === i && s.hovered
							)}
						key={`pipe-${pipe.id}`}
						onPathClick={() => this.onPipeClick(i)}
						onPathHover={() => this.onPipeHover(i)}
						onMouseLeave={() => this.onPipeMouseLeave(i)}
						pipeIndex={i}
						id={pipe.planet && 'clickable'}
					/>,
					<Pipe
						class={joinClasses(s.pipe, s[`pipe${i}`], s.pipeShadow)}
						key={`pipe-shadow-${pipe.id}`}
						pipeIndex={i}
					/>,
					this.pipesNeedingAnims.includes(i) && (
						<div class={joinClasses(s.pipeAnimContainer, s[`pipeAnimContainer${i}`])} ref={($ref) => this[`$pipeAnimContainer${i}`] = $ref} />
					)
				]))}
				<div class={s.pipeEntrances}>
					<PipeEntranceOutlines class={s.entrances} />
					<div class={joinClasses(s.circles, s.circleShadows)}>
						{pipes.map((pipe) => (
							<div
								class={joinClasses(s.circle, s.circleShadow)}
								key={`entrance-shadow-${pipe.id}`}
							/>
						))}
					</div>
					<div class={s.circles}>
						{pipes.map((pipe, i) => (
							<PipeEntrance
								class={
									joinClasses(
										s.circle,
										pipe.underConstruction && s.underConstruction,
										activePipeIndex === i && s.active,
										hoveredPipeIndex === i && s.hovered
									)}
								key={`entrance-${pipe.id}`}
								onHover={() => this.onPipeHover(i)}
								onClick={() => this.onPipeClick(i)}
								onMouseLeave={() => this.onPipeMouseLeave(i)}
								id={pipe.planet && 'clickable'}
							/>
						))}
					</div>
					{this.needsConstructionIcon && <img class={s.constructionIcon} src={`${imageRoot}/airport/ujpbd4.webp`} alt={copy.$altConstructionIcon} />}
				</div>
			</div>
		);
	}
}